import React, {Component} from 'react';
import {Button} from "reactstrap";
import Select from 'react-select';
import {deepCopyObject} from "../helper/helper";

class HeaderSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isListOpen: false,
            notInList: false,
            options: [],
            selectedValues: []
        }
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.checkInList = this.checkInList.bind(this);
        this.fetchData = this.fetchData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let list1 = this.props.options;
        let list2 = nextProps.options;
        if (list1 != list2) {
            this.setState({options: list2});
        }
    }

    onClick() {
        if (this.state.isListOpen) {
            this.setState({isListOpen: false});
        } else {
            this.setState({isListOpen: true}, () => this.props.onOpen());
        }
    }

    onChange(e) {
        let list = e;
        this.setState({selectedValues: list});
    }

    checkInList(e) {
        if (this.state.notInList) {
            this.setState({notInList: false});
        } else {
            this.setState({notInList: true});
        }
    }

    fetchData() {
        let self = this;
        let notInList = self.state.notInList;
        let selectedValues = deepCopyObject(this.state.selectedValues);
        let list = [];
        if (selectedValues != null) {
            selectedValues.map((value, i) => {
                list.push(value.value)
            });
        }
        self.props.handleSearch(list, notInList)
    }


    render() {
        return (
            <div>
                <div>{this.props.header}
                    <a onClick={this.onClick}>
                        <span className="">{" "}</span>
                        <i className="fa fa-search"/>
                    </a>
                </div>

                {this.state.isListOpen &&
                <div className="">
                    <div id="checkboxes">
                        <a style={{position:'absolute', zIndex : '1',
                                right: '5px', top: '-3px', padding: '5px', fontSize:'12px'}}
                           onClick={this.onClick}>x</a>
                        <div className='col-sm-12' style={{padding: '10px 10px 10px 20px'}}>
                            <div className='row'>
                                <div className="col-md-7" style={{paddingTop: '3px'}}>
                                    <label htmlFor="notInList">
                                        <input type="checkbox"
                                               id="notInList" name="notInList"
                                               checked={this.state.notInList}
                                               onChange={this.checkInList}/>
                                        <span> Seçilenleri Getirme</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <Select
                            className="multiselect"
                            isMulti
                            onChange={this.onChange}
                            options={this.state.options}
                            value = {this.state.selectedValues}
                            placeholder='Seçiniz'
                            noOptionsMessage={() => 'Sonuç bulunmadı'}
                        />
                        <div>
                            <Button className="TekBtn onizle"
                                    style={{
                                        marginTop: '10px',
                                        background: '#70a0bf',
                                    }}
                                    onClick={this.fetchData}
                            >Sorgula</Button>
                        </div>
                    </div>
                </div>
                }
            </div>
        )
    }
}

export default HeaderSearch;
